<template>
  <final-modal v-model="modalShow" @confirm="createDelay">
    <template v-slot:title>{{
      withData
        ? $t("general.update", { item: $t("general.delay") })
        : $t("general.add", { item: $t("general.delay") })
    }}</template>
    <div class="text-center">
      <div class="px-3 pt-0 pb-1">
        <div
          class="input-group mb-3"
          v-if="timeSheets.length > 1 && withData == false"
        >
          <span class="input-group-text" id="pausedAtTime">{{
            $t("general.teeSheet")
          }}</span>
          <select class="form-select" v-model="selectedTimeSheet">
            <option :value="null" disabled selected>
              {{
                $t("general.selectPlaceholder", {
                  item: $t("general.teeSheet"),
                })
              }}
            </option>
            <option
              v-for="(option, index) in timeSheets"
              :key="index"
              :value="option"
            >
              {{ option.title }}
            </option>
          </select>
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="pausedAtTime">{{
            $t("general.from")
          }}</span>
          <input
            class="form-control"
            type="time"
            id="pausedAtTime"
            name="pausedAtTime"
            :max="continuedAt"
            v-model="pausedAt"
            required
          />
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text" id="continuedAtTime">{{
            $t("general.until")
          }}</span>
          <input
            class="form-control"
            type="time"
            id="continuedAtTime"
            name="continuedAtTime"
            :min="pausedAt"
            v-model="continuedAt"
            required
          />
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text">{{ $t("general.reason") }}</span>
          <textarea class="form-control" v-model="reason"></textarea>
        </div>
      </div>
    </div>
    <template v-slot:actions>
      <div class="d-flex justify-content-between mx-3 mb-3">
        <div class="me-1">
          <button
            type="button"
            class="btn btn-outline-success"
            @click="withData ? updateDelay() : createDelay()"
          >
            {{
              withData
                ? $t("general.update", { item: $t("general.delay") })
                : $t("general.create", { item: $t("general.delay") })
            }}
          </button>
        </div>
        <div class="ms-2" v-if="withData">
          <button
            type="button"
            class="btn btn-outline-secondary"
            @click="deleteDelay"
          >
            {{ $t("general.delete", { item: $t("general.delay") }) }}
          </button>
        </div>
      </div>
    </template>
  </final-modal>
</template>

<script>
import FinalModal from "@/components/shared/final_modal.vue";
import { mapGetters } from "vuex";
import { http } from "@/http";
import { useToast } from "vue-toastification";
import { TOAST_CONFIGS } from "@/config/toasts";

export default {
  name: "DelayModal",
  components: {
    FinalModal,
  },
  setup() {
    return { toast: useToast() };
  },
  data() {
    return {
      modalShow: false,
      pausedAt: null,
      pausedAtUTC: null,
      continuedAt: null,
      continuedAtUTC: null,
      reason: null,
      withData: false,
      delayId: null,
      selectedTimeSheet: null,
    };
  },
  computed: {
    ...mapGetters({
      timeSheets: "timeSheets/timeSheets",
    }),
    timeSheet() {
      return this.selectedTimeSheet ?? this.timeSheets[0];
    },
  },
  watch: {
    pausedAt(newVal) {
      if (newVal) {
        const pausedAtDate = new Date(this.timeSheet?.date);
        pausedAtDate.setUTCHours(newVal.split(":")[0]);
        pausedAtDate.setUTCMinutes(newVal.split(":")[1]);
        pausedAtDate.setUTCSeconds(0);
        pausedAtDate.setUTCMilliseconds(0);
        this.pausedAtUTC = this.convertDateToUTC(pausedAtDate).toISOString();
        console.log(this.pausedAtUTC);
      } else {
        this.pausedAtUTC = null;
      }
    },
    continuedAt(newVal) {
      if (newVal) {
        const continuedAtDate = new Date(this.timeSheet?.date);
        continuedAtDate.setUTCHours(newVal.split(":")[0]);
        continuedAtDate.setUTCMinutes(newVal.split(":")[1]);
        continuedAtDate.setUTCSeconds(0);
        continuedAtDate.setUTCMilliseconds(0);
        this.continuedAtUTC =
          this.convertDateToUTC(continuedAtDate).toISOString();
        console.log(this.continuedAtUTC);
      } else {
        this.continuedAtUTC = null;
      }
    },
  },
  methods: {
    formatTime(time) {
      const hours = time.getHours();
      const minutes = time.getMinutes();
      return `${hours < 10 ? "0" : ""}${hours}:${
        minutes < 10 ? "0" : ""
      }${minutes}`;
    },
    convertDateToUTC(date) {
      return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds()
      );
    },
    getRequestBody() {
      return {
        timeSheetId: this.timeSheet.id,
        pausedAt: this.pausedAtUTC,
        continuedAt: this.continuedAtUTC,
        reason: this.reason,
        userName: this.$root.userInfo().name,
        userInitials: this.$root.userInfo().initials,
      };
    },
    createDelay() {
      http
        .post("/api/v1/time-sheet/delay", this.getRequestBody())
        .then(() => this.reset())
        .catch((err) => this.handleError(err));
    },
    updateDelay() {
      http
        .put(`/api/v1/time-sheet/delay/${this.delayId}`, this.getRequestBody())
        .then(() => this.reset())
        .catch((err) => this.handleError(err));
    },
    deleteDelay() {
      http
        .delete(`/api/v1/time-sheet/delay/${this.delayId}`)
        .then(() => this.reset())
        .catch((err) => this.handleError(err));
    },
    handleError(err) {
      console.error(err);
      this.toast.error(
        "Invalid data! Please check your input values.",
        TOAST_CONFIGS.INVALID_REQUEST_ERROR
      );
    },
    reset() {
      this.pausedAt = null;
      this.continuedAt = null;
      this.modalShow = false;
      this.reason = null;
      this.withData = false;
      this.delayId = null;
      this.selectedTimeSheet = null;
    },
    show(data) {
      this.reset();
      this.modalShow = true;
      if (data) {
        this.withData = true;
        this.delayId = data.id;
        this.pausedAt = this.formatTime(data.pausedAt);
        this.continuedAt = this.formatTime(data.continuedAt);
        this.reason = data.reason;
        this.selectedTimeSheet = this.timeSheets.find(
          (tS) => tS.id == data.timeSheetId
        );
      }
    },
  },
};
</script>
